import { Component } from "react";
import { Helmet } from "react-helmet";
import NavBar from "../NavBar";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
  FaArrowRight,
  FaRegClock,
  FaDollarSign,
  FaRecycle,
} from "react-icons/fa";
import Footer from "../Footer";
import "./index.css";

class Home extends Component {
  render() {
    return (
      <>
        <Helmet>
          <title>
            Simple Trash Solutions LLC | Professional Door-to-Door Trash
            Collection in Peoria, IL
          </title>
          <meta
            name="description"
            content="Experience efficient and reliable door-to-door trash collection services for apartment complexes in Peoria, IL, and nearby cities. Simplify waste management today!"
          />
          <link rel="canonical" href="https://simpletrashsolutionsllc.com/" />
        </Helmet>
        <div>
          <NavBar />
          <section className="home-bg-container">
            <div className="transperent-container">
              <div className="overlay"></div>
            </div>
            <div className="home-banner-content">
              <motion.div
                initial={{ opacity: 0, y: 60 }}
                animate={{ opacity: 1, y: 6 }}
                transition={{ duration: 1 }}
              >
                <h1 className="banner-heading-text">
                  Door-to-Door Trash Pickup
                  <br />
                  <span className="banner-heading-text span-text">
                    Made Simple
                  </span>
                </h1>
                <p className="banner-para">
                  Upgrade your apartment complex with our premium Door-to-Door
                  trash collection and trash valet service starting at $15 per
                  unit per month. Enjoy hassle-free Door-to-Door trash
                  collection and valet service.
                </p>
                <Link to="/about-us" className="link-name">
                  <button className="learn-more-button" name="learn more">
                    Learn More
                    <FaArrowRight className="arrow-icon" />
                  </button>
                </Link>
              </motion.div>
            </div>
          </section>

          <section className="featured-section">
            <div className="featured-container">
              <motion.div
                initial={{ opacity: 0, y: 60 }}
                animate={{ opacity: 1, y: 6 }}
                transition={{ duration: 1 }}
                className="animation-container"
              >
                <h1 className="main-heading-black">Why Choose Us</h1>
                <p className="featured-para">
                  We offer dependable trash valet services to ensure all your
                  garbage disposal needs are met with care. Plus, 10% of our
                  proceeds are donated to charity. Our door-to-door trash
                  collection service supports property owners, tenants, and
                  communities with effective and affordable trash removal
                  solutions.
                </p>
              </motion.div>

              <div className="featured-cards-container">
                <motion.div
                  initial={{ opacity: 0, y: 100 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 0.2 }}
                  viewport={{ once: true }}
                  className="card-container"
                >
                  <FaRegClock className="icons" />
                  <h1 className="card-heading">Convenient Pickup</h1>
                  <p className="card-para">
                    Let tenants enjoy hassle-free mornings with reliable trash
                    pickup options—Monday through Friday or
                    Monday/Wednesday/Friday.
                  </p>
                </motion.div>

                <motion.div
                  initial={{ opacity: 0, y: 100 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 0.4 }}
                  viewport={{ once: true }}
                  className="card-container"
                >
                  <FaRecycle className="icons" />
                  <h1 className="card-heading">Eco-Friendly Options</h1>
                  <p className="card-para">
                    We offer entrance/hallway bins designed for convenient
                    sorting of trash and recycling.
                  </p>
                </motion.div>

                <motion.div
                  initial={{ opacity: 0, y: 100 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 0.6 }}
                  viewport={{ once: true }}
                  className="card-container"
                >
                  <FaDollarSign className="icons" />
                  <h1 className="card-heading">Additional Revenue</h1>
                  <p className="card-para">
                    Generate extra income by offering this premium service to
                    your tenants.
                  </p>
                </motion.div>
              </div>
            </div>
          </section>
          <section className="upgrade-container">
            <div className="upgrade-contetn-container">
              <h2 className="upgrade-heading">
                Ready to Upgrade Your Property?
              </h2>
              <p className="upgrade-para">
                Join the growing number of properties offering premium waste
                management services.
              </p>
              <Link to="/contact-us" className="link-name">
                <button className="button-style" name="get start">
                  Get Start Today
                </button>
              </Link>
            </div>
          </section>
          <Footer />
        </div>
      </>
    );
  }
}

export default Home;
